import { render } from "./DouyinDecorateCard.vue?vue&type=template&id=4b20ed4f&scoped=true"
import script from "./DouyinDecorateCard.vue?vue&type=script&lang=js"
export * from "./DouyinDecorateCard.vue?vue&type=script&lang=js"

import "./DouyinDecorateCard.vue?vue&type=style&index=0&id=4b20ed4f&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b20ed4f"]])

export default __exports__